import { Shield, Award, Database, Flag } from "lucide-react";
import React from "react";

export function LendingPartners() {
  // Updated lending partners with placeholder logo paths
  const banks = [
    {
      name: "Bajaj Housing Finance",
      logo: "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/bajaj-housing-finserv-1745820611189.webp",
    },
    {
      name: "Aditya Birla Capital",
      logo: "https://minemiwebsite.s3.ap-south-1.amazonaws.com/assets/aditya-birla-capital-1745821822214.webp",
    },
  ];

  // Credibility indicators
  const credibilityIndicators = [
    {
      icon: <Shield className="h-10 w-10 text-[#59266D]" />,
      title: "CISA Certified",
      description:
        "Certified Information Systems Auditor (CISA) ensuring highest security standards",
    },
    {
      icon: <Award className="h-10 w-10 text-[#59266D]" />,
      title: "FACE Member",
      description: "Proud member of the Fintech Association of India (FACE)",
    },
    {
      icon: <Database className="h-10 w-10 text-[#59266D]" />,
      title: "Powered by Experian",
      description:
        "Credit scores and reports powered by Experian's trusted data",
    },
    {
      icon: <Flag className="h-10 w-10 text-[#59266D]" />,
      title: "Startup India Registered",
      description:
        "Registered under the Startup India program by DPIIT, Government of India.",
    },
  ];

  return (
    <section className="bg-white py-16">
      <div className="container  px-4 md:px-6">
        {/* Reasons to Believe Section */}
        <div className="mb-16">
          <h2 className="mb-2 text-center text-3xl font-extrabold">
            Why Trust MinEMI
          </h2>
          <p className="mb-10 text-center text-lg tracking-wide text-gray-600">
            Backed by credible institutions and industry certifications
          </p>

          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 px-2">
            {credibilityIndicators.map((indicator, index) => (
              <div
                key={index}
                className="flex flex-col items-center rounded-[24px] bg-[#EBE8FC] p-6 text-center border border-gray-200 shadow-none"
              >
                <div className="mb-4">{indicator.icon}</div>
                <h3 className="mb-2 text-[1.28rem] font-semibold tracking-wide">
                  {indicator.title}
                </h3>
                <p className="text-gray-600 tracking-wide">
                  {indicator.description}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-8 rounded-[24px] bg-gray-100 p-6 mx-2 text-center border border-gray-200 shadow-none">
            <p className="text-lg font-semibold tracking-wide m-0">
              Committed to the highest standards of data security and customer
              privacy
            </p>
          </div>
        </div>

        {/* Lending Partners Section */}
        <h2 className="pt-[70px] mb-12 text-center text-3xl font-bold">
          Our Lending Partners
        </h2>
        <div className="flex flex-wrap justify-center items-center gap-12 md:gap-16 lg:gap-20 max-w-4xl mx-auto">
          {banks.map((bank, index) => (
            <div
              key={index}
              className="flex items-center justify-center w-full md:w-auto"
            >
              <img
                src={bank.logo}
                alt={`${bank.name} logo`}
                width="120"
                height="40"
                className=" object-cover "
                loading="lazy"
              />
            </div>
          ))}
        </div>

        <div className="mt-12 text-center tracking-wide text-gray-500">
          <p>More banking partners coming soon...</p>
        </div>
      </div>
    </section>
  );
}
